var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lm-down-scaler"},[_c('div',{staticClass:"lm-scaler-inner",class:[{loaded: _vm.loaded}],style:(_vm.borderStyles)},[_c('div',{ref:"layout",staticClass:"lm-layout",style:(_vm.layoutStyle)},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }